import { compact } from '@lglp/utils';

import { SortBy } from '../../api/algolia';
import { DocumentType } from '../../types/document';
import {
  and,
  attr,
  attributeIn,
  periods,
} from '../algolia/algolia-filters-builder';

export const INVESTORS_PRESS_RELEASE_YEARS_LIMIT = 6;

export const searchInvestorsPressRelease = ({
  hitsPerPage = 10,
  investorsThemes,
  investorsYears,
  investorsMonths,
}: SearchInvestorsPressReleaseProps = {}): SearchInvestorsPressReleaseReturnProps => {
  return compact<SearchInvestorsPressReleaseReturnProps>({
    hitsPerPage,
    sortBy: SortBy.PUBLISHED_AT,
    filters: and(
      [
        attr('type', DocumentType.PRESS_RELEASE),
        investorsThemes && attributeIn('investorsThematics')(investorsThemes),
        periods(
          'publication_date',
          getperiods(investorsYears, investorsMonths)
        ),
        attr('onFinance', 'true'),
        // onInvestorsDashboard && attr('onInvestorsDashboard', 'true'),
      ].filter(Boolean) as string[]
    ),
  });
};
const getperiods = (
  investorsYears: string[],
  investorsMonths: string[]
): { from: number; to: number }[] => {
  if (investorsYears?.length > 0) {
    if (investorsMonths?.length > 0) {
      //Filtre par mois et années
      return investorsMonths
        .map((month) =>
          investorsYears.map((year) => ({
            from: new Date(Number(year), Number(month)).getTime(),
            to: new Date(Number(year), Number(month) + 1, 0, 23, 59).getTime(),
          }))
        )
        .flat();
    }
    //Filtre par années
    return investorsYears?.map((year) => ({
      from: new Date(Number(year), 0).getTime(),
      to: new Date(Number(year), 12, 0, 23, 59).getTime(),
    }));
  }
  const currentDate = new Date();
  //Max N années
  return [
    {
      from: new Date(
        currentDate.getFullYear() - INVESTORS_PRESS_RELEASE_YEARS_LIMIT,
        12
      ).getTime(),
      to: currentDate.getTime(),
    },
  ];
};

type SearchInvestorsPressReleaseProps = {
  hitsPerPage?: number;
  investorsThemes?: string[];
  investorsYears?: string[];
  investorsMonths?: string[];
};

type SearchInvestorsPressReleaseReturnProps = {
  hitsPerPage: number;
  sortBy: SortBy;
  filters: string;
};
